var React = require('react');

function SuccessCheck (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#FFF","d":"M0 13C0 5.82 5.819 0 13 0c7.18 0 13 5.819 13 13 0 7.18-5.819 13-13 13-7.18 0-13-5.819-13-13z","key":0}),React.createElement("path",{"fill":"#F55700","d":"M4 13a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9z","key":1}),React.createElement("path",{"fill":"#FFF","d":"M9.247 13.557a.8.8 0 0 0-1.19 1.071l1.941 2.155a.905.905 0 0 0 1.272.066l6.613-5.954a.8.8 0 1 0-1.07-1.19l-6.094 5.487-1.472-1.635z","key":2})]));
}

SuccessCheck.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26"};

module.exports = SuccessCheck;

SuccessCheck.default = SuccessCheck;
